import { Scaffold } from 'layouts';
import { StockBalance } from 'components/Pages/ScheduledReports';

export const StockBalancePage = () => {
  return (
    <Scaffold>
      <StockBalance />
    </Scaffold>
  );
};
